import React from 'react';

const SimplePopoverOption = ({ label, onClick, Icon }) => {
    return (
        <div onClick={onClick} aria-hidden='true' className="item-option clickable-option">
            <Icon className="edit-icon" />
            <span className='toggle-action'>{label}</span>
        </div>
    );
};

export default SimplePopoverOption;